import { isFunction } from 'lodash'

export class DoubleClickHandler {
  #options = {
    delay: 300
  }
  #timer = null

  constructor(options = {}) {
    this.#options = { ...this.#options, ...options }
  }

  dispatch(handler) {
    if (!isFunction(handler)) {
      console.error('DoubleClickHandler: handler is not a function')
      return
    }

    this.clearTimeout()

    this.#timer = setTimeout(handler, this.#options.delay)
  }

  destroy() {
    this.clearTimeout()
  }

  clearTimeout() {
    clearTimeout(this.#timer)
  }
}
